import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=38622321&lang=pug&"
import script from "./Ribbon.vue?vue&type=script&lang=ts&"
export * from "./Ribbon.vue?vue&type=script&lang=ts&"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=38622321&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports